// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div#alert-group-status-app[data-v-7e8ca0a6] {
  width: 100%;
}
.alert-group-status-container[data-v-7e8ca0a6] {
  max-width: unset !important;
  margin-left: 0 !important;
  margin-right: 0 !important;
  padding-top: 0;
  padding-bottom: 0;
  margin-top: 0;
  height: 100%;
  width: 100%;
}
.alert-group-status-container .vy-table-wrapper[data-v-7e8ca0a6] {
  margin-top: 4px;
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/moi-alert-group-status/alertGroupStatus.vue","webpack://./alertGroupStatus.vue"],"names":[],"mappings":"AACA;EACE,WAAA;ACAF;ADGA;EACE,2BAAA;EACA,yBAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;EAEA,aAAA;EACA,YAAA;EACA,WAAA;ACDF;ADGE;EACE,eAAA;ACDJ","sourcesContent":["\ndiv#alert-group-status-app {\n  width: 100%;\n}\n\n.alert-group-status-container {\n  max-width: unset!important;\n  margin-left: 0!important;\n  margin-right: 0!important;\n  padding-top: 0;\n  padding-bottom: 0;\n\n  margin-top: 0;\n  height: 100%;\n  width: 100%;\n\n  .vy-table-wrapper {\n    margin-top: 4px;\n  }\n}\n\n","div#alert-group-status-app {\n  width: 100%;\n}\n\n.alert-group-status-container {\n  max-width: unset !important;\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-top: 0;\n  height: 100%;\n  width: 100%;\n}\n.alert-group-status-container .vy-table-wrapper {\n  margin-top: 4px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
